export default __webpack_public_path__ + "static/media/banners_working_chimp1.ec7b6faa.png";